import { SaveData } from "types/common";
import {
  SET_SAVE_DATA,
  SET_TVL,
  SET_INSTALLED_EXTENSION,
  SET_IS_EXTENSION_INSTALLED,
  SET_ACCOUNT_BALANCE,
  SET_SELECTED_ACCOUNT,
  SET_TRANSACTION_TYPE,
  SET_STATUS,
  SET_TRANSACTION_STATUS,
  SET_WITHDRAW_STATUS,
  SET_WITHDRAW_ID,
  SET_TRANSACTION_ID,
  SET_CONNECTED_ACCOUNT_TYPE,
  SET_BLADE_EXTENSION_INSTALLED,
  SET_SHOW_WALLET_MODAL,
  SET_FIRESTORE_DATA,
  SET_DEFI_DATA,
  SET_UNDER_MAINTENANCE_DATA,
  SET_CONTRACT_TYPE,
} from "./constants";

let bladeConnect: any;

const INITIAL_SAVE_DATA: SaveData = {
  topic: "",
  pairingString: "",
  privateKey: "",
  pairedAccounts: [],
  pairedWalletData: null,
  walletExtensionType: "",
};

const initialState = {
  saveData: INITIAL_SAVE_DATA,
  installedExtensions: null,
  isExtensionInstalled: false,
  accountBalance: null,
  tvl: 0,
  selectedAccount: "",
  transactionType: "stake",
  status: "INITIALIZING",
  transactionStatus: "",
  withdrawStatus: "NONE",
  withdrawId: null,
  transactionId: null,
  connectedAccountType: "",
  isBladeExtensionInstalled: Boolean(bladeConnect),
  walletModal: false,
  maintainanceData: {
    isActive: false,
    id: "hedera-protocol-staking-state-mainnet",
    updatedAt: Date.now(),
  },
};

const reducer = (state: any, action: any) => {
  switch (action.type) {
    case SET_SAVE_DATA:
      return {
        ...state,
        saveData: action.payload.saveData,
      };
    case SET_TVL:
      return {
        ...state,
        tvl: action.payload.tvl,
      };
    case SET_INSTALLED_EXTENSION:
      return {
        ...state,
        installedExtensions: action.payload.installedExtensions,
      };
    case SET_IS_EXTENSION_INSTALLED:
      return {
        ...state,
        isExtensionInstalled: action.payload.isExtensionInstalled,
      };
    case SET_ACCOUNT_BALANCE:
      return {
        ...state,
        accountBalance: action.payload.accountBalance,
      };
    case SET_SELECTED_ACCOUNT:
      return {
        ...state,
        selectedAccount: action.payload.selectedAccount,
      };
    case SET_TRANSACTION_TYPE:
      return {
        ...state,
        transactionType: action.payload.transactionType,
      };
    case SET_STATUS:
      return {
        ...state,
        status: action.payload.status,
      };
    case SET_TRANSACTION_STATUS:
      return {
        ...state,
        transactionStatus: action.payload.transactionStatus,
      };
    case SET_WITHDRAW_STATUS:
      return {
        ...state,
        withdrawStatus: action.payload.withdrawStatus,
      };
    case SET_WITHDRAW_ID:
      return {
        ...state,
        withdrawId: action.payload.withdrawId,
      };
    case SET_CONTRACT_TYPE:
      return {
        ...state,
        contractType: action.payload.contractType,
      };
    case SET_TRANSACTION_ID:
      return {
        ...state,
        transactionId: action.payload.transactionId,
      };
    case SET_CONNECTED_ACCOUNT_TYPE:
      return {
        ...state,
        connectedAccountType: action.payload.connectedAccountType,
      };
    case SET_BLADE_EXTENSION_INSTALLED:
      return {
        ...state,
        isBladeExtensionInstalled: action.payload.isBladeExtensionInstalled,
      };
    case SET_SHOW_WALLET_MODAL:
      return {
        ...state,
        walletModal: action.payload.walletModal,
      };
    case SET_FIRESTORE_DATA:
      return {
        ...state,
        firestoreData: action.payload.firestoreData,
      };
    case SET_DEFI_DATA:
      return {
        ...state,
        defiData: action.payload.defiData,
      };
    case SET_UNDER_MAINTENANCE_DATA:
      return {
        ...state,
        maintainanceData: { ...action.payload },
      };
    default:
      return state;
  }
};

export { reducer, initialState, INITIAL_SAVE_DATA };
